module.exports = __webpack_public_path__ + "img/ywbk10_en.d621f590.jpg";